import type { IconProps } from './../../models/icon';

export function LightbulbIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M18 13.7144C18.0039 12.6445 17.7218 11.5931 17.1828 10.6689C16.6438 9.74479 15.8675 8.98158 14.9343 8.45838C14.0011 7.93516 12.945 7.67097 11.8754 7.69319C10.8058 7.71541 9.76157 8.02322 8.85091 8.58472C7.94026 9.14623 7.19631 9.94101 6.69612 10.8867C6.19594 11.8325 5.95772 12.8947 6.00615 13.9635C6.05458 15.0322 6.38787 16.0686 6.97153 16.9652C7.5552 17.8618 8.36797 18.5861 9.32568 19.0629V22.0114C9.33013 22.1858 9.40255 22.3515 9.52745 22.4733C9.65235 22.595 9.81985 22.663 9.99425 22.6629H14.0057C14.1801 22.663 14.3476 22.595 14.4725 22.4733C14.5974 22.3515 14.6698 22.1858 14.6742 22.0114V19.0114C15.6621 18.5198 16.4952 17.7651 17.0819 16.8306C17.6686 15.896 17.9863 14.8177 18 13.7144Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18 13.7141C18.0039 12.6443 17.7218 11.5928 17.1828 10.6687C16.6438 9.74453 15.8675 8.98133 14.9343 8.45812C14.0011 7.93492 12.945 7.67073 11.8754 7.69294C10.8058 7.71516 9.76157 8.02296 8.85091 8.58448C7.94026 9.14599 7.19631 9.94077 6.69612 10.8865C6.19594 11.8322 5.95772 12.8945 6.00615 13.9632C6.05458 15.032 6.38787 16.0683 6.97153 16.965C7.5552 17.8616 8.36797 18.5859 9.32568 19.0627V22.0112C9.33013 22.1856 9.40255 22.3513 9.52745 22.4729C9.65235 22.5946 9.81985 22.6628 9.99425 22.6627H14.0057C14.1801 22.6628 14.3476 22.5946 14.4725 22.4729C14.5974 22.3513 14.6698 22.1856 14.6742 22.0112V19.0112C15.6621 18.5196 16.4952 17.7649 17.0819 16.8303C17.6686 15.8958 17.9863 14.8175 18 13.7141Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 1.38867V3.9601"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.8572 3.83997L17.04 5.67425"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.7658 9.15424H20.1943"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M5.14307 3.83997L6.96021 5.67425"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M1.23438 9.15424H3.8058"
        />
      </g>
    </svg>
  );
}
